import z from 'zod';

export const passwordSchema = z
    .string()
    .min(8, { message: 'Password must be at least 8 characters long' });

export const emailSchema = z.object({
    email: z.email({ message: 'Invalid email address' }),
});

export const registerSchema = z.object({
    name: z.string().min(1, { message: 'Name is required' }),
    email: z.email({ message: 'Invalid email address' }),
    password: passwordSchema,
});

export const loginSchema = z.object({
    email: z.email({ message: 'Invalid email address' }),
    password: z.string().min(1, { message: 'Password is required' }),
});

export const forgotPasswordSchema = z.object({
    email: z.email({ message: 'Invalid email address' }),
});

export const verifyOtpSchema = z.object({
    email: z.email({ message: 'Invalid email address' }),
    password: passwordSchema,
    otp: z.string().min(6, { message: 'OTP must be at least 6 characters' }),
});

export const otpSchema = z.object({
    code: z.string().min(6, { message: 'OTP must be 6 characters long' }),
});

export const backupCodeSchema = z.object({
    code: z
        .string()
        .min(10, { message: 'Backup code must be 10 characters long' }),
});
export const passwordConfirmationSchema = z.object({
    password: z.string().min(1, { message: 'Password is required' }),
});

export const changePasswordSchema = z
    .object({
        currentPassword: z.string().min(1, {
            message: 'Current password is required',
        }),
        newPassword: passwordSchema,
        confirmPassword: z.string(),
        revokeOtherSessions: z.boolean().optional(),
    })
    .refine((data) => data.newPassword === data.confirmPassword, {
        message: "Passwords don't match",
        path: ['confirmPassword'], // path of error
    });

export const ssoLoginSchema = z.object({
    email: z.email({ message: 'Invalid email address' }),
});

export const createRoleSchema = z.object({
    name: z
        .string()
        .min(2, { message: 'Role name must be at least 2 characters long' })
        .max(50, { message: 'Role name must be less than 50 characters' })
        .regex(/^[a-zA-Z0-9\s\-_]+$/, {
            message:
                'Role name can only contain letters, numbers, spaces, hyphens and underscores',
        }),
    permissions: z
        .array(z.string())
        .min(1, { message: 'At least one permission must be selected' }),
});
